<template>
  <div class="login">
    <LayoutHeader></LayoutHeader>
    <div class="login__container">
      <div class="login__container-header flex flex--align-end flex--justify-between">
        <div class="title">
          <h1>欢迎访问</h1>
          <h2>
            体素AI测肤开发平台
            <span> V1.0</span>
          </h2>
        </div>
        <div class="btn">
          <router-link to="/register">
            <Button type="primary" shape="circle">注册账户</Button>
          </router-link>
        </div>
      </div>
      <div class="login__container-body">
        <Tabs :animated="false" v-model="loginType">
          <TabPane label="密码登录" name="user">
            <LoginByUsername v-if="loginType === 'user'"></LoginByUsername>
          </TabPane>
          <TabPane label="短信登录" name="phone">
            <LoginByPhone v-if="loginType === 'phone'"></LoginByPhone>
          </TabPane>
        </Tabs>
        <div class="login__container-footer">
          <router-link to="/forget-password"
                       v-show="loginType === 'user'">
            忘记密码?
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from '@/components/layout/layoutHeader.vue';
import LoginByUsername from './loginByUsername.vue';
import LoginByPhone from './loginByPhone.vue';

export default {
  name: 'Login',
  components: {
    LoginByUsername,
    LoginByPhone,
    LayoutHeader,
  },
  data() {
    return {
      loginType: 'user',
    };
  },
};
</script>

<style lang="less">
  @prefix: ~'login';
  .@{prefix}{
    width: 100vw;
    height: 100vh;
    background-image: url("../../assets/login/bg-login.jpeg");
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    position: relative;
    min-height: 725px;
    &__container{
      width: 560px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: -40px;
      &-header{
        padding: 0 8px 32px;
        .title{
          h1{
            font-size: 24px;
            color: rgb(81, 69, 139);
            line-height: 32px;
            margin-bottom: 8px;
            font-weight: 500;
          }
          h2{
            font-size: 18px;
            color: rgb(81, 69, 139);
            line-height: 24px;
            font-weight: 500;
            span{
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
        .btn{
          padding-bottom: 3px;
          .ivu-btn{
            width: 112px;
            height: 36px;
            padding: 0;
            font-size: 14px;
          }
        }
      }
      &-body{
        box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .1),
        0 6px 30px 5px rgba(0, 0, 0, .08),
        0 8px 10px 0 rgba(0, 0, 0, .16);
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        height: 440px;
        .@{prefix}__msg-valid-btn{
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          padding: 0;
          box-shadow: none;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          color: @primary-color;
          &[disabled]{
            color: #bfbfbf;
            background-color: transparent;
            &:hover{
              color: #bfbfbf;
              background-color: transparent;
            }
          }
          &:hover{
            background-color: transparent;
          }
        }
        .ivu-tabs-nav-scroll{
          background-color: rgb(236, 239, 241);
        }
        .ivu-tabs-bar{
          margin-bottom: 0;
        }
        .ivu-tabs-nav{
          .ivu-tabs-tab{
            height: 56px;
            line-height: 56px;
            padding: 0;
            width: 104px;
            text-align: center;
            font-weight: 500;
            &:hover{
              color: @primary-color;
            }
          }
        }
        .ivu-tabs-ink-bar{
          height: 3px;
        }
        .ivu-tabs-content{
          padding: 22px 16px 28px;
        }
        .ivu-form-item{
          margin-bottom: 36px;
        }
        .ivu-input{
          border-color: rgba(0, 0, 0, 0.12);
          border-radius: 8px;
          height: 36px;
          line-height: 36px;
          padding: 0 16px;
          color: #000;
          &:focus{
            border-color: @primary-color;
          }
        }
        .ivu-input-suffix i{
          line-height: 36px;
          font-size: 20px;
        }
        .ivu-btn-long{
          padding: 0;
          height: 36px;
          font-size: 14px;
          font-weight: 500;
          &[disabled] {
            background-color: rgba(0, 0, 0, 0.12);
            border: none;
            color: rgba(0, 0, 0, 0.26);
            &:hover{
              background-color: rgba(0, 0, 0, 0.12);
              border: none;
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
      }
      &-footer{
        text-align: center;
        a{
          font-weight: 500;
          color: @primary-color;
        }
      }
    }
    &__valid-form-item.ivu-form-item{
      padding-right: 144px;
      position: relative;
      margin-bottom: 60px;
    }
    &__valid-img{
      position: absolute;
      width: 140px;
      text-align: right;
      top: 0;
      right: -144px;
      img{
        width: 103px;
        height: 34px;
        vertical-align: middle;
      }
      p{
        line-height: 20px;
        color: rgba(0, 0, 0, 0.54);
        font-weight: 500;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
      }
    }
    &__msg-valid-item{
      position: relative;
    }
  }
</style>
